import React, { createContext, useContext, useState } from 'react';
import translations from '@/i18n/translations';

const LangContext = createContext();

const LANGS = [
  { code: 'en', label: 'EN', flag: 'GB' },
  { code: 'fr', label: 'FR', flag: 'FR' },
  { code: 'ru', label: 'RU', flag: 'RU' },
  { code: 'ar', label: 'AR', flag: 'SA' },
  { code: 'zh', label: 'ZH', flag: 'CN' },
];

export function LangProvider({ children }) {
  const [lang, setLang] = useState('en');
  const t = translations[lang] || translations.en;
  const isRTL = lang === 'ar';
  return (
    <LangContext.Provider value={{ lang, setLang, t, isRTL, LANGS }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
